export interface DriveCampaign {
  workspaceId: string;
  id: string;
  name: string;
  description: string;
  logo: string;
  banner: string;
  expectedMad: number;
  projectLeaders: string[];
  priority: string;
  criteria: string;
  status: string;
  timelines: string;
  assetList: string;
  visualizations: string[] | null;
  productName: string;
  cncManager: string[] | null;
  activeProduct: string;
  base64Logo: string | null;
  base64Banner: string | null;
  isArchived: boolean;
  archived: boolean;
}

export interface CampaignMilestone {
  name: string;
  mad: string;
  actualDate: string;
  driveDate: string;
  negotiatedDate: string;
  id: string;
  status: string;
  showMilestone: boolean;
  showTasks: boolean;
  showProjects: boolean;
  showProjectsBlock: boolean;
  showProjectStage: boolean;
  driveCampaignId: string;
  isNegociated: boolean;
  blockColor: string;
  blockName?: string;
  activeMilestone?: boolean;
  items?: CampaignMilestone[];
}

export enum TimelineDisplayMode {
  Horizontal = 'horizontal',
  VerticalList = 'verticalList',
  HorizontalMultiLine = 'horizontalMultiLine',
}

export interface Html2PdfOptions {
  margin?: number | [number, number] | [number, number, number, number];
  filename?: string;
  image?: {
    type?: 'jpeg' | 'png' | 'webp';
    quality?: number;
  };
  enableLinks?: boolean;
  html2canvas?: object;
  jsPDF?: {
    unit?: string;
    format?: string | [number, number];
    orientation?: 'portrait' | 'landscape';
  };
}

export interface CampaignSimulatorParams {
  expectedMad: string;
  timelineCriteria: string;
  brandId: string;
}

export interface CampaignSimulatorResponse {
  expectedMad: number;
  timelineCriteria: string;
  brandId: string;
  timelines: string;
}

